export default "__VITE_ASSET__BEsNYv6t__"